import React from 'react';

// Pins its children just under the fixed 56px top bar. The padded, page-colored wrapper fills the
// gap above the card so scrolled content doesn't show through between the two.
export const StickyBar = ({ className = '', children }) => (
  <div className="sticky top-14 z-20 -mt-3 bg-background pt-3">
    <div className={className}>{children}</div>
  </div>
);

export default StickyBar;
